import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'orderReturnHistories';
export const orderReturnHistoriesActions = makeActions(
  MODEL_NAME,
  'id',
  'order-return-histories',
);

export const getAllOrderReturnHistories = orderReturnHistoriesActions.getAll;
export const editOrderReturnHistories = orderReturnHistoriesActions.edit;
export const createOrderReturnHistories = orderReturnHistoriesActions.create;
export const getByIdOrderReturnHistories =
  orderReturnHistoriesActions.getDataById;
